// This file is a modal specific for the AddressBookCSVUpload. RosterUpdate uses the standard AddressModal,
// And since it renders it with some specific props, we need to re-render it here in order to allow edit address
// of invalid identities in a different way.

import withModal from '../../../../../../../../components/global/modal/withModal';
import UserAddressForm from '../../../../../../../../components/global/user-address/UserAddressForm';

export const CSV_UPLOAD_ADDRESS_MODAL = 'CSV_UPLOAD_ADDRESS_MODAL';

export default withModal(UserAddressForm, {
  name: CSV_UPLOAD_ADDRESS_MODAL,
  size: 'sm',
  hideHeader: true,
  dismissible: false,
});
